import React, { useState } from 'react';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { StyledTextPairing, StyledGetStartedButton } from './FundSection.styles';
import { InfiniteSlider } from '@components/InfiniteSlider';
import { BABY_REGISTRY } from 'src/pages/baby-registry';
import { useTranslation } from 'react-i18next';

export const FundSection: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('babyRegistry');
  const fundSectionData = t('customCashFund');

  return (
    <Box as={'section'} paddingY={[10, 12]} id="BabyRegistry_Fund_Section">
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)} threshold={0}>
        <div />
      </LazyLoadWrapper>
      <Columns marginBottom={12}>
        <Columns.Column width="full">
          <Flex
            alignItems={'center'}
            flexDirection={'column'}
            style={{ maxWidth: 780, marginLeft: 'auto', marginRight: 'auto' }}
            marginBottom={[7, 7]}
          >
            <StyledTextPairing
              alignment={'center'}
              eyebrow={fundSectionData.eyebrow}
              eyebrowTagName="h2"
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow24"
              title={fundSectionData.title}
              titleTagName={'h2'}
              titleColor={'neutra6'}
              titleVariant={'hed56'}
              body={fundSectionData.body}
              bodyColor={'neutra5'}
              bodyVariant={'featureCopy17'}
            />
          </Flex>
          <Flex alignItems="center" justifyContent="center">
            <Box>
              <StyledGetStartedButton id="babyRegistryFundGetStartedBtn" variant="secondary" page={BABY_REGISTRY}>
                {fundSectionData.getStarted}
              </StyledGetStartedButton>
            </Box>
          </Flex>
        </Columns.Column>
      </Columns>
      <InfiniteSlider scrollName="baby-registry-brands" images={[...fundSectionData.productList]} speed={6} gap={{ sm: 50, belowSm: 30 }} />
    </Box>
  );
};
